module.exports = __webpack_public_path__ + "static/media/023-man-6.9f6a6683.svg";